(function () {
  var GRID_SELECTOR = '#loadMoreContent';
  var ITEM_SELECTOR = '#loadMoreContent > .grid__item';
  var PAGINATION_SELECTOR = '.js-pagination-wrapper';
  var LOAD_MORE_BTN = '.js-load-more';

  var grid = document.querySelector(GRID_SELECTOR);
  if (!grid) return;

  /* ---------- MODE A: theme's own "Show more" AJAX button ---------- */
  /* If the theme renders .js-load-more, just auto-click it when it nears the viewport. */
  function setupLoadMoreMode() {
    var lastClick = 0;

    function autoClick() {
      var btn = document.querySelector(LOAD_MORE_BTN);
      if (!btn || btn.offsetParent === null) return false;
      var rect = btn.getBoundingClientRect();
      if (rect.top <= window.innerHeight + 600) {
        var now = Date.now();
        if (now - lastClick > 800) {           // debounce repeat clicks
          lastClick = now;
          btn.click();
        }
        return true;
      }
      return false;
    }

    window.addEventListener('scroll', autoClick, { passive: true });
    // Re-check shortly after each append (button is replaced/removed by the theme)
    var poll = setInterval(function () {
      var btn = document.querySelector(LOAD_MORE_BTN);
      if (!btn) { /* keep polling: a filter change may add a new button */ }
      autoClick();
    }, 700);
    autoClick();
    // never clear poll: filter/sort changes re-render a fresh button we still want to handle
  }

  /* ---------- MODE B: numbered pagination (fetch + append) ---------- */
  function setupNumberedMode(pagination) {
    var currentPage = parseInt(pagination.getAttribute('data-page') || '1', 10);
    var maxPage = currentPage;
    pagination.querySelectorAll('.js-pagination-item[aria-label^="Page"]').forEach(function (a) {
      var n = parseInt((a.getAttribute('aria-label') || '').replace(/\D/g, ''), 10);
      if (!isNaN(n) && n > maxPage) maxPage = n;
    });
    if (maxPage <= currentPage) return;

    pagination.style.display = 'none';

    function pageUrl(p) {
      var url = new URL(window.location.href);
      url.searchParams.set('page', p);
      return url.pathname + '?' + url.searchParams.toString();
    }

    var nextPage = currentPage + 1, loading = false, done = false;

    var loader = document.createElement('div');
    loader.style.cssText = 'grid-column:1/-1;text-align:center;padding:2rem;';
    grid.appendChild(loader);
    function setLoader(s) {
      loader.style.opacity = s === 'loading' ? '0.6' : '1';
      loader.style.cursor = s === 'loading' ? 'default' : 'pointer';
      loader.textContent = s === 'loading' ? 'Loading more…' : 'Load more';
    }
    setLoader('loading');

    function loadNext() {
      if (loading || done || nextPage > maxPage) return;
      loading = true; setLoader('loading');
      fetch(pageUrl(nextPage), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newItems = doc.querySelectorAll(ITEM_SELECTOR);
          newItems.forEach(function (item) { grid.insertBefore(item, loader); });
          doc.querySelectorAll(PAGINATION_SELECTOR + ' .js-pagination-item[aria-label^="Page"]').forEach(function (a) {
            var n = parseInt((a.getAttribute('aria-label') || '').replace(/\D/g, ''), 10);
            if (!isNaN(n) && n > maxPage) maxPage = n;
          });
          nextPage++; loading = false;
          if (nextPage > maxPage || newItems.length === 0) {
            done = true; observer.disconnect(); loader.remove();
          } else { setLoader('idle'); requestAnimationFrame(maybeLoad); }
        })
        .catch(function () { loading = false; setLoader('idle'); });
    }

    function maybeLoad() {
      if (loading || done) return;
      if (loader.getBoundingClientRect().top <= window.innerHeight + 600) loadNext();
    }

    var observer = new IntersectionObserver(function (e) {
      if (e[0].isIntersecting) loadNext();
    }, { rootMargin: '600px 0px' });
    observer.observe(loader);
    window.addEventListener('scroll', maybeLoad, { passive: true });
    loader.addEventListener('click', function () { if (!loading && !done) loadNext(); });
    maybeLoad();
  }

  /* ---------- decide which mode this page uses ---------- */
  var pagination = document.querySelector(PAGINATION_SELECTOR);
  if (document.querySelector(LOAD_MORE_BTN) || !pagination) {
    setupLoadMoreMode();          // covers .js-load-more collections
  }
  if (pagination) {
    setupNumberedMode(pagination); // covers numbered-pagination collections
  }
})();